<template>
  
   <span>
      <span class="w3-badge w3-green">{{fieldModelValue}}</span>&nbsp;
      <span @click="changevalue(-1)" class="w3-button w3-small w3-circle w3-ripple w3-black minmaxbuttons">&#8249;</span>&nbsp;
      <span @click="changevalue(1)" class="w3-button w3-small w3-circle w3-ripple w3-black minmaxbuttons">&#8250;</span>&nbsp;              
    </span> 

  <!-- <select style="width:100px" class="w3-select" v-model="fieldModelValue">
    <option selected>1</option>
    <option>2</option>                  
  </select>     -->

</template>

<script>
  export default {

      props: {

        value :{
          default: 0,
          type: Number
        },
        min :{
          default: 0,
          type: Number
        },
        max :{
          default: 1,
          type: Number
        }
      },
      
      methods:{
        changevalue(number){
          let newcompare = this.fieldModelValue + number
          if(newcompare <= this.max && newcompare >=this.min)          
              this.fieldModelValue = newcompare          
        }
      }, 
      created(){       

        this.fieldModelValue = this.fieldModelValue===0 && this.min>0?this.min:this.fieldModelValue

      },
      computed: { 
        fieldModelValue: {
            get() {
              return this.value;
            },
            set(newValue) {                    
              this.$emit('input', newValue);
            }
        } 
    }
  };
</script>

<style>
 .minmaxbuttons:hover {
    color: #fff!important;
    background-color: #009688!important;
  }
  
  .minmaxbuttons {
    background-color: #9e9e9e!important
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/QuantitySelector.vue